<div class="bp-table" #table>
  <div class="bp-table-thead">
    <div class="bp-table-header-row">
      <ng-container *ngTemplateOutlet="headers; context: { $implicit: items }"> </ng-container>
    </div>
    <div class="bp-table-row-separator"></div>
  </div>

  <!-- Normal table without drag&drop -->
  @if (!isDraggable) {
    <div class="bp-table-tbody">
      @for (row of items; track row; let last = $last) {
        <div
          class="bp-table-row-wrapper"
          [elementIsIntoView]="last"
          (scrolledIntoView)="onScrolledToBottom()"
          (click)="onClick(row)"
          (keydown.enter)="onClick(row)">
          <div class="bp-table-row" tabindex="0">
            <ng-container *ngTemplateOutlet="rows; context: { $implicit: row }"></ng-container>
          </div>
          <div class="bp-table-row-separator"></div>
        </div>
      }
      <ng-container *ngTemplateOutlet="message; context: { $implicit: items }"></ng-container>
    </div>
  }

  <!-- Table with drag&drop support -->
  @if (isDraggable) {
    <div
      class="bp-table-tbody draggable"
      cdkDropList
      [cdkDropListData]="items"
      (cdkDropListDropped)="itemDropped($event)">
      @for (row of items; track row; let last = $last) {
        <div
          class="bp-table-row-wrapper"
          [elementIsIntoView]="last"
          (scrolledIntoView)="onScrolledToBottom()"
          (click)="onClick(row)"
          (keydown.enter)="onClick(row)"
          cdkDrag
          [cdkDragData]="row"
          cdkDragBoundary=".cdkContainer">
          <ng-container>
            <div class="draggable-dots-wrapper">
              <span cdkDragHandle class="draggable-dots-container">
                <img
                  class="draggable-dots"
                  src="/assets/images/icon-6-dots.png"
                  alt="{{ 'logo_alt_text' | translate }}" />
              </span>
            </div>
          </ng-container>
          <div class="bp-table-row" tabindex="0">
            <ng-container *ngTemplateOutlet="rows; context: { $implicit: row }"></ng-container>
          </div>
          <div class="bp-table-row-separator"></div>
        </div>
      }
      <ng-container *ngTemplateOutlet="message; context: { $implicit: items }"></ng-container>
    </div>
  }
</div>
